import React from "react";

/**
 * Toggle button for sidebar collapse state.
 * DC-UX-SIDEBAR-NO-PERSIST-DEFAULT-COLLAPSED-006: Now a controlled component only.
 * 
 * Props:
 * - collapsed (boolean, required): Current collapsed state
 * - onToggle (function, required): Callback when toggle is clicked
 */
function SidebarCollapseToggle({ collapsed, onToggle }) {
  return (
    <button
      aria-label="Toggle sidebar"
      data-collapsed={collapsed ? "true" : "false"}
      onClick={onToggle}
    >
      {collapsed ? "▶" : "◀"}
    </button>
  );
}

export default SidebarCollapseToggle;
